import { PropType, ExtractPropTypes } from 'vue'
import { InputProps as WxInputProps } from '@tarojs/components'

export const businessLicenseInputProps = {

  /* 值 */
  modelValue: {
    type: String,
    default: '',
  },

  /* 文本对齐 */
  textAlign: {
    type: String as PropType<'left' | 'right'>,
    default: 'left',
  },

  /* 最大长度 */
  maxLength: {
    type: Number,
    default: 18, // 标准规定统一社会信用代码用18位阿拉伯数字或大写英文字母表示
  }
}

export type BusinessLicenseInputProps = Partial<ExtractPropTypes<typeof businessLicenseInputProps>> & WxInputProps